import { Component, OnInit } from '@angular/core';
import { map, takeUntil, tap } from 'rxjs/operators';
import { LayoutService } from '@shared/services/layout.service';
import { Observable, Subject } from 'rxjs';
import { Router } from '@angular/router';
import { LcoRoutesMap } from '../../../lco/lco-routing.module';
import { LcoConfig } from '@shared/config';
import { LcoService } from '../../../lco/services/lco.service';

@Component({
  selector: 'app-footer-lco-nav',
  templateUrl: './footer-lco-nav.component.html',
  styleUrls: ['./footer-lco-nav.component.scss']
})
export class FooterLcoNavComponent implements OnInit {
  private destroySubject = new Subject();
  loading: boolean = false;
  menuType$: Observable<'master'|'slave'>;

  constructor(private layoutService: LayoutService,
              private lcoService: LcoService,
              private router: Router) { }

  ngOnInit(): void {
    this.layoutService.loading$
      .pipe(takeUntil(this.destroySubject))
      .subscribe(loading => {
        this.loading = loading;
      });

    // todo friend QR code condition
    const friendQrCode = false;

    this.layoutService.config = {
      lcoMenu: {
        type: friendQrCode ? 'slave' : 'master'
      }
    }

     this.menuType$ = this.layoutService.config
       .pipe(takeUntil(this.destroySubject))
       .pipe(map((config: LcoConfig) => config.lcoMenu.type))
  }

  manageTable() {

  }

  addFriend() {

  }

  orderFlow() {
    const orderFlowUrl = `${LcoRoutesMap.base}/${LcoRoutesMap.tacitFlow}`;
    // this.router.navigate([orderFlowUrl]);
  }

  payFlow() {

  }

  openChatBot() {
    // todo chatbot OR chatbot in iframe
  }
}
